import Vue from "vue";//引入vue
import VueRouter from "vue-router";//引入vue路由
Vue.use(VueRouter);//挂载路由
import indexT from '../components/sy/index.vue'
import zbindex from "@/components/zb/zbindex.vue";
import geren from "@/components/sy/geren.vue";
import fx from "@/components/sy/faxian.vue";
import noe from "@/components/shezhi/noe.vue";
import shangchuan from "@/components/shezhi/shagnchuan.vue";
import kaibo from "@/components/shezhi/kaibo.vue";
import yinsi from "@/components/shezhi/yinsi.vue";
import xieyi from "@/components/shezhi/xieyi.vue";
import dl from "@/components/sy/dl.vue";
import tr from "@/components/sy/tr.vue";

const routes=[
    {
        name:'indexT',//首页
        path:'/',
        component:indexT
    },
    {
        name:'zbindex',//直播间
        path:'/zb',
        component:zbindex
    },
    {
        name:'geren',//个人中心
        path:'/gr',
        component:geren
    },
    {
        name:'fx',//发现
        path:'/fx',
        component:fx
    },
    {
        name:'shezhi',//设置
        path:'/shezhi',
        component:noe
    },
    {
        name:'shangchuan',//上传
        path:'/scsp',
        component:shangchuan
    },
    {
        name:'tr',//上传
        path:'/tr',
        component:tr
    },
    {
        name:'kaibo',//开播
        path:'/kaibo',
        component:kaibo
    },
    {
        name:'yinsi',//隐私政策
        path:'/yinsi',
        component:yinsi
    },
    {
        name:'xieyi',//用户协议
        path:'/xieyi',
        component:xieyi
    },
    {
        name:'login',//登录注册
        path:'/login',
        component:dl
    }
]
const router = new VueRouter({ // 生成一个路由实例
    routes//配置项-配置视图和路由之间的对应关系
});

// ========== 新增：全局屏蔽重复路由跳转报错 ==========
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 仅忽略重复导航错误，其他路由异常正常抛出
    if (err.name !== 'NavigationDuplicated') throw err
  })
}
// =================================================

//导出路由
export default router